import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import car_1 from './assets/car_1.jpg';
import car_4 from './assets/car_3.jpg';
import car_3 from './assets/car_4.jpg';
import car_5 from './assets/car_5.jpg';
import car_6 from './assets/car_6.jpg';
import car_7 from './assets/car_7.jpg';
import car_8 from './assets/car_8.jpg';
import './carousel-custom.css';

const CarouselComponent = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  return (
    <div className="w-full" style={{ maxWidth: '900px', margin: '0 auto' }}>
      <Carousel
        showThumbs={false}
        autoPlay={false}
        interval={3000}
        infiniteLoop
        selectedItem={currentSlide}
        onChange={index => setCurrentSlide(index)}
        showStatus={false}
        className="carousel-custom"
      >
        {/* 1 */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_1}
            alt="Car 1"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">

I have gained experience with several variants-to-function (V2F) approaches and am eager to apply these skills to advance our understanding of aging and disease mechanisms, ultimately contributing to the development of effective treatments and cures.

            </p>
        </div>

        {/* 2 */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_3}
            alt="Car 3"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">
            Full-stack and data-driven developer with a biomedical edge
          </p>
        </div>

        {/* 3 (moved here from #6) */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_6}
            alt="Car 6"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">
            Cellprofiler Segmentation workflow: nuclei, cells, cytoplasm, and lipid objects
          </p>
        </div>

        {/* 4 (was #3 originally) */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_4}
            alt="Car 4"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">
Experienced in integrating a LocusZoom plot (top-left), donut plot generator (top-right), and stack plot (bottom-right) within a Flask–React web application, 
and in uploading Haploreg variant and linkage disequilibrium (LD) data to an SQL database.
            </p>
        </div>

        {/* 5 */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_5}
            alt="Car 5"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">
Experienced in generating microplate platemap figures (top-left), using CellProfiler for nuclei, cell, 
and cytoplasm segmentation and feature extraction (top-left); performing regression analyses (middle-top); 
and visualizing control versus experimental groups using connected-arrow plots (top-right) 
or volcano plots displaying effect size and statistical significance along the x- and y-axes.
          </p>
        </div>

        {/* 6 (YouTube moved here) */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <iframe
            title="YouTube Video"
            width="100%"
            height="310"
            src="https://www.youtube.com/embed/hEOKye3S25c"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
          <p className="legend">
            [Multifunctional Wheelchair: Coded Arduino, Devised Electrical Circuits, and Produced Video Demo]{' '}
            <a
              href="https://www.linkedin.com/pulse/project-summary-multifunctional-wheelchair-ryan-cho"
              target="_blank"
              rel="noreferrer"
              style={{ color: 'white', fontWeight: 'bold', textDecoration: 'underline' }}
            >
              https://www.linkedin.com/pulse/project-summary-multifunctional-wheelchair-ryan-cho
            </a>
          </p>
        </div>

        {/* 7 */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_7}
            alt="Car 7"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">[Korean Army] Served as Information Systems Technician. Discharged as Sergeant </p>
        </div>

        {/* 8 */}
        <div style={{ backgroundColor: 'lightgray' }}>
          <img
            src={car_8}
            alt="Car 8"
            style={{ height: '600px', objectFit: 'contain', maxWidth: '100%' }}
          />
          <p className="legend">[Autodesk Maya] 3D Modeling, Animation. I made this at the Washington University in St. Louis, in a course called Animated World!</p>
        </div>
      </Carousel>
    </div>
  );
};

export default CarouselComponent;
